module.exports = __webpack_public_path__ + "img/ATRC Platform - Privacy Policy -5.15c800f8.png";